import React from 'react'
import Grid from 'components/styled-components-grid'
import {ELEMENTS_IDS} from 'const'
import {getBackUrl} from 'utils/browserUtils'
import RingierBanner from './ringier-banner'
import LoginLink from './link/LoginLink'
import LogisterMethod from './LogisterMethod'
import {getConfigValue} from '../../../../utils'
import {LogisterPageSeparator} from './LogisterPageStyles'
import ProgressBar from 'components/progress-bar'

const LogisterPageGrid = ({
  loginCase,
  loginHint,
  loginMethods,
  isHintedLogin,
  t,
  gameConfig,
  shouldShowRingierBanner,
  ...props
}) => {
  const halign = isHintedLogin || !shouldShowRingierBanner ? 'center' : 'left'
  const backUrl = getBackUrl()
  const shouldShowSeparator = getConfigValue('separatorLanding')

  return (
    <Grid valign="top" halign={halign}>
      <Grid.Unit size={{portrait: 1 / 2}}>
        {backUrl && (isHintedLogin || !shouldShowRingierBanner) && (
          <LoginLink id={ELEMENTS_IDS.logisterPage.backToBrand} to={backUrl} external target="_self">
            {t('back-link')}
          </LoginLink>
        )}
        <ProgressBar />
        <LogisterMethod
          {...props}
          t={t}
          loginCase={loginCase}
          loginHint={loginHint}
          loginMethods={loginMethods}
          isHintedLogin={isHintedLogin}
          gameConfig={gameConfig}
        />
      </Grid.Unit>
      {!isHintedLogin && shouldShowRingierBanner && (
        <Grid.Unit size={{portrait: 1 / 2}} visible={{smallMobile: false, portrait: true}}>
          {shouldShowSeparator && <LogisterPageSeparator />}
          <RingierBanner loginCase={loginCase} gameBanner={gameConfig.banner} gameImage={gameConfig.image} />
        </Grid.Unit>
      )}
    </Grid>
  )
}

export default LogisterPageGrid
